import React from "react";
import {cn} from "../utils";

const ArrowUpCircleIcon = (
    {
        className,
        color
    }: {
        className?: string,
        color?: string
    } & React.SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="21"
        viewBox="0 0 20 21"
        width="20"
        className={cn(className)}
        xmlns="http://www.w3.org/2000/svg">
        <path clipRule="evenodd"
              d="m0 10.3906c0 5.5229 4.47715 10 10 10 5.5228 0 10-4.4771 10-10 0-5.52282-4.4772-9.999975-10-9.999975-5.52285 0-10 4.477155-10 9.999975zm13.5303-1.03031-3-2.99999c-.2929-.2929-.76774-.2929-1.06063 0l-3 2.99999c-.29289.2929-.29289.76781 0 1.06071.29289.2928.76777.2928 1.06066 0l1.71968-1.71973v5.38933c0 .4142.33579.75.74999.75s.75-.3358.75-.75v-5.3893l1.7197 1.7197c.2929.2928.7677.2928 1.0606 0 .2929-.2929.2929-.76781 0-1.06071z"
              fill={color || "currentColor"} fillRule="evenodd"/>
    </svg>
);

export {ArrowUpCircleIcon};